import MapDisplay from "~/components/address/MapDisplay.tsx";
import Card from "~/components/Card/Card";
import CardValue from "~/components/Card/components/CardValue.tsx";
import Label from "~/components/formElements/Label/Label";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import type { Client } from "~/modules/client/api/client/clientTypes.ts";
import { useAllCurrencies } from "~/modules/country/api/currency/currencyQueries.ts";
import getOneOfCollection from "~/utils/getOneOfCollection.ts";

type ClientsBillingDetailsProps = {
	clientData: Client;
};

const ClientsBillingDetails: React.FunctionComponent<ClientsBillingDetailsProps> = ({
	clientData,
}) => {
	const {
		address,
		comment,
		currencyId,
		invoiceByMail,
		paymentTargetDays,
		travelExpensesIncluded,
	} = clientData;

	const { data: allCurrenciesData } = useAllCurrencies();

	const currencyDisplayName = currencyId ? getOneOfCollection(allCurrenciesData, currencyId, "displayName") : "n/a";

	const showMap = !!address?.addressLine1 && !!address?.postCode && !!address?.city;

	return (
		<div className="flex flex-col gap-y-8">
			<div className="grid w-full grid-cols-2 gap-x-2">
				<Card>
					<div className="grid grid-cols-2 gap-4">
						{[
							{
								label: "Rechnung per",
								value: invoiceByMail ? "Mail" : "Post",
							},

							{
								label: "Zahlungsziel",
								value: paymentTargetDays ? `${paymentTargetDays} Tage` : EMPTY_VALUE_PLACEHOLDER,
							},
							{
								label: "Reisekosten inkludiert",
								value: travelExpensesIncluded ? "Ja" : "Nein",
							},
							{
								label: "Währung",
								value: currencyDisplayName || EMPTY_VALUE_PLACEHOLDER,
							},

						].map(({ label, value }, index) => (
							<CardValue key={`contacts-${index}`}
									   label={label}>
								{value}
							</CardValue>
						))}
						<div className="col-span-2">
							<CardValue label="Rechnungsbesonderheiten">
								{comment || EMPTY_VALUE_PLACEHOLDER}
							</CardValue>
						</div>
					</div>
				</Card>
				<Card>
					<Label size="sm">Adresse</Label>
					{showMap && address ? <MapDisplay address={address} name={clientData.displayName} /> : EMPTY_VALUE_PLACEHOLDER}
				</Card>
			</div>
		</div>
	);
};

export default ClientsBillingDetails;
